module.exports = __webpack_public_path__ + "img/Vector_lamp.cb33cdea.svg";